export default __webpack_public_path__ + "static/media/cloudwatch.4c924084.svg";